import { getAddLogoToLibraryUrl, getCurrentCanvas, qtyProxy, setPopupLoader } from "../../../helpers/helper";
import { apiUrls, errorMessages, fileTypeSupport, LIST_LIMIT, maxFileSize } from "../../../assets/config";
import { images } from "../../../assets/images/index";
import { uploadLogo } from "./uploadLogoController";
import { CheckTechniqueGradientSupport } from "./techniqueBaseOperations";
import { removeBackgroundCheckbox } from "./popupController";
import { addLogoApiCallHandler, deleteLogoApiCallHandler, fetchLogoListApiCallHandler } from "../../../helpers/apiHelper";

const logoLibraryDialog = document.getElementById("logoLibraryDialog") as HTMLDialogElement;
const rootElement = document.getElementById("jasani_product_builder");
const odooBaseUrl = rootElement?.getAttribute("data-url");
const authToken = rootElement?.getAttribute("data-auth-token");

const getParsedLogoDetails = (additional_attribute) => {
  const rawAdditionalAttribute = additional_attribute;
  const validJsonString = rawAdditionalAttribute.replace(/'/g, '"');
  return JSON.parse(validJsonString);
};

function clearUploadLogoInputValue() {
  const logoBtn = document.getElementById("uploadLogoToLibrary") as HTMLButtonElement;
  if (!logoBtn) return;
  logoBtn.value = "";
}

export function validateImage(file) {
  if (file) {
    if (fileTypeSupport.includes(file.type)) {
      const size = file.size / 10024 / 10024;
      if (size > maxFileSize) {
        clearUploadLogoInputValue();
        alert(errorMessages.LOGO_FILE_GREATER);
        return false;
      }
      return true;
    }
    clearUploadLogoInputValue();
    alert(errorMessages.LOGO_FORMATE_ISSUE);
    return false;
  }
  return false;
}

export const deleteLogoFromLibrary = async (id) => {
  try {
    await deleteLogoApiCallHandler(`${getAddLogoToLibraryUrl(odooBaseUrl)}/${id}`, authToken);
    qtyProxy["page"] = 1;
    scrollTopToListController();
    fetchLogoLibraryList(Number(qtyProxy["page"]), Number(qtyProxy["limit"]), true);
    checkIsShowLoadMore();
  } catch {
    alert(errorMessages.SERVER_ERROR);
  }
};

const bindDeleteLogoEvenHelper = () => {
  const deleteBtn = document.getElementById("deleteLogoFromLibrary")
  deleteBtn.addEventListener("click", () => {
    const selectedLogo = qtyProxy["selectedLogoFromLibrary"];
    deleteLogoFromLibrary(selectedLogo?.id);
  });
};

function base64ToFile(base64, filename) {
  // Split the base64 string to get the MIME type and the data
  const [mimeString, base64Data] = base64.split(",");
  const byteCharacters = atob(base64Data); // Decode base64 string
  const byteNumbers = new Array(byteCharacters.length);

  // Convert byte characters to byte numbers
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);

  // Create a Blob from the byte array
  const blob = new Blob([byteArray], { type: mimeString.split(":")[1].split(";")[0] });

  // Create a File object from the Blob
  const file = new File([blob], filename, { type: blob.type });
  return file;
}

const clearLogoAndCheckBoxSelection = () =>{
  const removeButton = document.getElementById('removeBackgroundFromLogo') as HTMLInputElement;
  const logoItems = document.querySelectorAll(".selected-library-logo");
  removeButton.checked = false;

  logoItems.forEach((item) => {
      if (item.classList.contains("active")) {
        item.classList.remove("active");
      }
  });
};

const ChooseAndDeleteDisableHanler = (isDisable : boolean) =>{
  const deleteBtn = document.getElementById("deleteLogoFromLibrary") as HTMLButtonElement;
  const addLogoToLibraryBtn = document.getElementById("addLibraryLogoToCanvas") as HTMLButtonElement;
  const removeBgBox = document.getElementById("removeBgBox");
  addLogoToLibraryBtn.disabled = isDisable;
  deleteBtn.disabled = isDisable;
  removeBgBox.style.display = isDisable ? "none" : "block";
}

export async function addLogoToLibraryApiHandler(name, image, url, file) {
  const dataToSendOdoo = { name, image, additional_attribute: { url, file: file } };

  try {
    const res = await addLogoApiCallHandler(getAddLogoToLibraryUrl(odooBaseUrl), authToken, dataToSendOdoo);
    if (res?.status === "created") {
      scrollTopToListController("instant");
      qtyProxy["selectedLogoFromLibrary"] = {};
      qtyProxy["page"] = 1;
      fetchLogoLibraryList(Number(qtyProxy["page"]), Number(qtyProxy["limit"]), true);
      return;
    }
    alert(errorMessages.SERVER_ERROR);
  } catch {
    setPopupLoader(false);
    alert(errorMessages.SERVER_ERROR);
  }
}

export async function fetchLogoLibraryList(page, limit, isDelete = false) {
  setPopupLoader(true);
  ChooseAndDeleteDisableHanler(true);
  const logoLibraryListEl = document.getElementById("logoLibraryList");
  const htmlForAddLogoToLibrary = `<label class="library-logo-item" id="uploadNewLogo">
                <input id="uploadLogoToLibrary" type="file" />
                <img src=${images?.["Plus_icon"]} alt="upload logo">
                <p>NEW</p>
            </label>`;

  try {
    const { logos: logoList, total_count } = await fetchLogoListApiCallHandler(`${getAddLogoToLibraryUrl(odooBaseUrl)}?page=${page}&limit=${limit}`, authToken);
    qtyProxy["totalRecords"] = total_count;
    checkIsShowLoadMore();
    // If isDelete is true, clear the current logos and only keep the updated ones
    if (isDelete) {
      logoLibraryListEl.innerHTML = "";
      qtyProxy["tempLogoLibrary"] = [];
    }

    qtyProxy["tempLogoLibrary"] = qtyProxy["tempLogoLibrary"] ? [...qtyProxy["tempLogoLibrary"], ...logoList] : [...logoList];

    let newLogos = logoList
      .map(
        (logo) => `
      <label class="library-logo-item selected-library-logo">
          <input type="radio" name="logo" value="${logo?.id}" hidden>
          <img src="${getParsedLogoDetails(logo.additional_attribute).url}" alt="${logo?.id}">
      </label>
  `
      )
      .join("");

    // Remove existing uploadNewLogo if it exists
    const existingUploadNewLogo = document.getElementById("uploadNewLogo");
    if (existingUploadNewLogo) {
      existingUploadNewLogo.remove();
    }

    // Append new logos to the logoLibraryList
    if (newLogos?.length > 0) logoLibraryListEl.insertAdjacentHTML("beforeend", newLogos);

    // Append the upload new logo element at the end
    logoLibraryListEl.insertAdjacentHTML("afterbegin", htmlForAddLogoToLibrary);

    const logoLibraryList = qtyProxy["tempLogoLibrary"] ?? [];
    const logoItems = document.querySelectorAll(".selected-library-logo");

    logoItems.forEach((item) => {
      item.addEventListener("click", function (e) {
        const removeBgBox = document.getElementById("removeBgBox");
        qtyProxy["selectedLogoFromLibrary"] = logoLibraryList?.find((logo) => logo.id == (e.target as HTMLInputElement).value);
        logoItems.forEach((el) => el.classList.remove("active"));
        this.classList.add("active");
        removeBgBox.style.display = "block";
        ChooseAndDeleteDisableHanler(false);
      });
    });
    const addLogoToLibraryBtn = document.getElementById("uploadLogoToLibrary") as HTMLButtonElement;
    addLogoToLibraryBtn?.addEventListener("change", addLogoToLibraryHandlerWrapper);
    setPopupLoader(false);
    handleLazyLoading();
    return logoList ?? [];
  } catch {
    setPopupLoader(false);
  }
}

async function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result; // This will be in the format: "data:[<mediatype>];base64,[<base64data>]"
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file); // Read file as Data URL (base64)
  });
}

export async function addLogoToLibraryHandler(event) {
  const files = event.target.files;
  if (!files || files.length === 0) alert(errorMessages.UPLOAD_FILE);
  if (!validateImage(files[0])) {
    return;
  }

  const requestObj = new FormData();
  requestObj.append("file", files[0]);
  setPopupLoader(true);

  const reader = new FileReader();

  reader.onloadend = async () => {
    const file = await getBase64(files[0]);

    try {
      const response = await fetch(apiUrls.imageConvert, {
        method: "POST",
        body: requestObj,
      });
      const data = await response.json();
      if (!data.data.image) {
        alert(errorMessages.LOGO_NOT_PROPER);
        return;
      }
      const imgURL = apiUrls.convertedImage.concat(data?.data?.image);

      if (data.data.isGradient === "True" && CheckTechniqueGradientSupport() && !confirm(errorMessages.CONFIRMATION_GRADIENT_MESSAGE_TECHNIQUE)) {
        return;
      }
      addLogoToLibraryApiHandler(files[0]?.name, "", imgURL, file);
      clearUploadLogoInputValue();
    } catch (error) {
      alert(errorMessages.SERVER_ERROR);
      removeBackgroundCheckbox();
      setPopupLoader(false);
    }
  };

  reader.onerror = (error) => {
    console.error("File reading error:", error);
  };

  // Read the file as a data URL (base64)
  reader.readAsDataURL(files[0]);
}

export const addLogoToLibraryHandlerWrapper = (event) => {
  addLogoToLibraryHandler(event).catch((error)=>{
    console.error(error);
    setPopupLoader(false);
  })
}

export const addLibraryLogoToCanvasHandler = () => {
  const addLogoToLibraryBtn = document.getElementById("addLibraryLogoToCanvas") as HTMLButtonElement;
  addLogoToLibraryBtn.addEventListener("click", () => {
    logoLibraryDialog.close();
    uploadLogo(base64ToFile(getParsedLogoDetails(qtyProxy?.["selectedLogoFromLibrary"]?.additional_attribute)?.file, qtyProxy?.["selectedLogoFromLibrary"]?.name), qtyProxy?.["selectedLogoFromLibrary"]?.id);
    qtyProxy["selectedLogoFromLibrary"] = {};
    clearLogoAndCheckBoxSelection();
    ChooseAndDeleteDisableHanler(true);
  });
};

const scrollTopToListController = (behavior: "instant" | "smooth" = "instant") => {
  const firstLogo = document.querySelector(".library-logo-item"); // Assert as HTMLElement
  if (firstLogo) {
    firstLogo.scrollIntoView({
      behavior,
      block: "start",
    });
  }
};

export const isLogoPresentInCurrentPosition = () => {
  const addedLogos =  getCurrentCanvas()?.getObjects()?.filter((obj) => obj.type === "image") ?? [];
  if(addedLogos?.length >= 1){
    alert(errorMessages?.LOGO_TEXT_LIMIT);
    return true;
  }
  return false;
}

export function openAndCloseLogoLibraryHandler() {
  const openLogoLibraryButton = document.getElementById("openLogoLibrary");
  const closeLogoLibraryButton = document.getElementById("closeLogoLibrary");

  openLogoLibraryButton.addEventListener("click", () => {
    if(isLogoPresentInCurrentPosition()){
     return;
    }
    logoLibraryDialog.showModal();
  });
  closeLogoLibraryButton.addEventListener("click", () => {
    // scrollTopToListController()
    logoLibraryDialog.close();
    qtyProxy["selectedLogoFromLibrary"] = {};
    qtyProxy["page"] = 1;
    clearLogoAndCheckBoxSelection();
    ChooseAndDeleteDisableHanler(true);
  });
}

export const handleLazyLoading = () => {
  // Select the loader element
  const loader = document.getElementById("lazyLoader");

  // Create an intersection observer
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Stop observing the loader
          observer.unobserve(loader);

          if (!checkIsShowLoadMore()) {
            return;
          }

          qtyProxy["page"] += 1;
          fetchLogoLibraryList(Number(qtyProxy["page"]), Number(qtyProxy["limit"]));
        }
      });
    },
    {
      root: null, // Use the viewport as the root
      rootMargin: "0px",
      threshold: 1.0, // Trigger when the loader is fully visible
    }
  );

  // Start observing the loader element
  observer.observe(loader);
};

function checkIsShowLoadMore() {
  // Select the loader element
  const loader = document.getElementById("lazyLoader");
  if (qtyProxy["totalRecords"] <= Number(qtyProxy["page"]) * Number(qtyProxy["limit"])) {
    loader.style.display = "none";
    return false;
  }

  loader.style.display = "block";
  return true;
}

export const renderLogoListHTML = async () => {
  if (!(qtyProxy["page"] || qtyProxy["limit"])) {
    qtyProxy["page"] = 1;
    qtyProxy["limit"] = LIST_LIMIT;
    qtyProxy["totalRecords"] = 30;
  }

  logoLibraryDialog.innerHTML = `
      <div class="loading" id="popupLoader">
          <div class="loading-gif"></div>
      </div>
      <div class="logo-library-header">                     
         <h1>SAVED LOGOS</h1>
         <button id="closeLogoLibrary">
         <figure>
              <img src=${images?.["Close_icon"]} alt="close button">
         </figure>
         </button>
      </div>
      <div class="logo-library-body">
          <div class="logo-library-list" id="logoLibraryList">
          
          </div>
          <div id="lazyLoader"></div>
      </div>
          <div class="remove-bg-box" id="removeBgBox">
              <input type="checkbox" id="removeBackgroundFromLogo">
              <label for="removeBackgroundFromLogo">Remove Background From Logo</label>
          </div>
      <div class="modal-popup-toolBtn">
          <button class="new-secondary-btn btn-sm" id="deleteLogoFromLibrary">Delete</button>
          <button class="new-primary-btn btn-sm" id="addLibraryLogoToCanvas">Choose</button>
      </div>
      `;

  openAndCloseLogoLibraryHandler();
  addLibraryLogoToCanvasHandler();
  bindDeleteLogoEvenHelper();
};
